<template>
<!-- 积分获取规则 -->
    <div class="get_rule">
        <img class="img" src="../assets/getrule.png">
    </div>
</template>

<script>
export default {
    props: {

    },
    data() {
        return {

        };
    },
    computed: {

    },
    created() {

    },
    mounted() {

    },
    watch: {

    },
    methods: {

    },
    components: {

    },
};
</script>

<style scoped>
.get_rule {
    /* background: #fff; */
    padding: 28px;
}
.get_rule .img{
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/GetRules.vue